<template>
  <div>
    <div class="demand-content" v-if="ready">
      <p class="title">{{ title }}</p>
      <h2 class="subtitle">{{ subTitle }}</h2>
      <div v-if="success">
        <img
          v-if="card_or_onsite && card_or_onsite.paymentMethod == 'onsite'"
          src="@/assets/img/dialog/png/yen.png"
          alt=""
        />
        <img v-else src="@/assets/img/dialog/png/done.png" alt="" />
        <table border="1" class="info">
          <tr>
            <th>予約番号：</th>
            <th style="font-size: 2rem">{{ reservationCode }}</th>
          </tr>
          <tr>
            <th>人数(内訳)：</th>
            <th>
              <span v-if="seatCount.adult"
                >おとな{{ seatCount.adult }}名 <br
              /></span>
              <span v-if="seatCount.child"
                >こども{{ seatCount.child }}名 <br
              /></span>
              <span v-if="seatCount.infant"
                >幼児{{ seatCount.infant }}名 <br
              /></span>
            </th>
          </tr>
          <tr>
            <th>決済状況：</th>
            <th
              v-if="card_or_onsite && card_or_onsite.paymentMethod == 'onsite'"
            >
              車内でのお支払い
            </th>
            <th v-else>アプリ決済</th>
          </tr>

          <tr
            v-if="
              payment &&
              card_or_onsite &&
              card_or_onsite.paymentMethod == 'onsite'
            "
          >
            <th>乗車料金：</th>
            <th>{{ totalPrice }}円</th>
          </tr>
        </table>
      </div>
      <img v-else src="@/assets/img/dialog/png/alert.png" alt="" />

      <p class="bottom-text">この画面をドライバーにお見せください</p>
      <button @click="returnNativeApp()" class="bottom-button">OK</button>
    </div>

    <!-- ローディングダイアログ -->
    <DialogLoading ref="DialogLoading" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TemplateBOK",

  mounted() {},
  data() {
    return {
      ready: false,
      title: null,
      subTitle: null,
      success: true,

      reservationCode: null,
      seatCount: null,
      reservationID: null,

      payment: null,
    };
  },
  methods: {
    async BOK() {
      this.$refs.DialogLoading.openDialog();

      try {
        var param = this.$route.fullPath.split("?")[1];
        var apiParams = {
          qr_message: `${param}`,
        };

        // POST demand-pickup-complete
        var resp = await this.$store.dispatch("demand/postPickupReservation", {
          apiParams: apiParams,
        });

        this.title = "乗車確認が完了しました";
        this.reservationCode = resp.data.reservationCode;
        this.seatCount = resp.data.seatCount;
        this.reservationID = resp.data.id;

        // GET demand-payment?master_bookingservice_id=${service_id}&reservation_id=${id}
        this.payment = await this.$store.dispatch("demand/getDemandPayment", {
          id: this.reservationID,
          service_id: this.$route.query.master_bookingservice_id,
        });
      } catch (err) {
        this.success = false;
        this.$refs.DialogLoading.closeDialog();

        switch (err.response.data.error) {
          case "reservation_not_found":
            this.title = "乗車確認に失敗しました";
            this.subTitle = "有効な予約が見つかりません";
            break;
          case "wrong_car":
            this.title = "乗車確認に失敗しました";
            this.subTitle = "車両が間違っています";
            break;
        }
      }
      this.ready = true;
      this.$refs.DialogLoading.closeDialog();
    },
  },
  computed: {
    totalPrice() {
      var total = 0;
      this.payment.passengers.forEach((ticket) => {
        total += ticket.price;
      });
      return total;
    },
    card_or_onsite() {
      return this.payment.passengers.find(
        (element) =>
          element.paymentMethod == "card" || element.paymentMethod == "onsite"
      );
    },
    ...mapGetters("demand", ["Reservation"]),
  },
};
</script>

<style lang="scss" scoped>
.demand-content {
  width: 100%;
  margin: auto;
  text-align: center;
  position: relative;
  height: 100vh;
  padding: 0;
  .title {
    font-size: 1.5rem;
    padding-top: 12vh;
  }
  .subtitle {
    padding: 3vh;
  }
  img {
    width: 50%;
    max-width: 200px;
  }
}

.info {
  font-size: 1rem;
  line-height: 1.5rem;
  width: 100%;
  margin-top: 5vh;
  tr th:first-child {
    text-align: right;
    font-weight: 100;
    width: 45%;
  }
  tr th:last-child {
    font-size: 1.2rem;
    text-align: left;
    padding-left: 10px;
  }
}

.bottom-text {
  position: absolute;
  bottom: 8vh;
  font-size: 1rem !important;
  font-weight: bold;
  position: absolute;
  width: 100%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}

.bottom-button {
  background: #fdc138;
  width: 100%;
  display: block;
  border: none;
  margin: auto;
  font-size: 1rem;
  color: white;
  font-weight: bold;
  padding: 2vh;
  position: absolute;
  bottom: 0;
  left: 0%;
}
</style>
